import { BaseCrossAnalysisUseCase } from './base-cross-analysis-use-case'
import { IQueryRepository } from '../repositories/i-query-repository'

export class LandUseConflictUseCase extends BaseCrossAnalysisUseCase {
  readonly id = 'land-use-conflict'
  readonly name = 'Conflicto de Uso del Suelo (CUM vs Uso Real)'

  constructor(queryRepo: IQueryRepository) {
    super(queryRepo)
  }
}
